import React, { useEffect } from 'react';

const GoogleTranslate = () => {
  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,ar,fr,es,fil,th,hi,te',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          'google_translate_element_inner'
        );
      }
    };

    const script = document.createElement('script');
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);

    const style = document.createElement('style');
    style.id = 'google-translate-override-styles';
    style.innerHTML = `
      .goog-te-combo {
        border: 1px solid #ccc !important;
        border-radius: 4px !important;
        padding: 6px 8px !important;
        background-color: #f9f9f9 !important;
        cursor: pointer !important;
        font-size: 14px !important;
        font-family: 'Arial', sans-serif !important;
        outline: none !important;
        background-image: url('data:image/svg+xml;utf8,<svg fill="%23555" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>') !important;
        background-repeat: no-repeat !important;
        background-position: right 8px center !important;
        background-size: 16px !important;
      }

      .goog-te-gadget-simple {
        background-color: transparent !important;
        border: none !important;
        font-size: 0 !important;
        width: 100% !important;
      }
      .goog-te-gadget-simple a {
        display: none !important;
      }

      .goog-tooltip-skiptranslate, .goog-tooltip {
        display: none !important;
      }

      .skiptranslate.goog-te-gadget {
        display: inline-block !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
      const existingStyle = document.getElementById('google-translate-override-styles');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        top: 30,
        right: 30,
        zIndex: 1000,
        background: 'white',
        padding: '12px 16px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        color: '#333',
        minWidth: '200px',
        gap: '8px',
      }}
    >
      {/* Google Logo */}
      {/* <img
        src="https://www.gstatic.com/images/branding/product/1x/translate_24dp.png"
        alt="Google Translate"
        style={{ width: 20, height: 20 }}
      /> */}
      {/* Label */}
      <span style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>Choose Language:</span>
      {/* Actual dropdown injected by Google */}
      <div id="google_translate_element_inner" />
    </div>
  );
};

export default GoogleTranslate;
